import 'normalize.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/global.css';

import React from 'react';

import { RootProviders } from './providers';
import { AppRouter } from './routers';

export function App() {
  return (
    <RootProviders>
      <AppRouter />
    </RootProviders>
  );
}
